module.exports = __webpack_public_path__ + "static/media/dual-diagnosis-active.0ffa3506.svg";